// @ts-nocheck
/*import {
  ROUTER_STATE_CHANGE
} from '../constants/actions';*/
import ActionTypes from "../constants/actions";

export default (state = [], action) => {
  switch (action.type) {
    case ActionTypes.SEARCH_TEAM_BY_NAME:
      return action.teams;
    default:
      return state;
  }
};
